import React from "react";
import { TableHeader, TableHeaderCell, CellSeparator } from "../CustomTableStyles";
import Colors from "../../../themes/Colors";

const TableHeaders = ({
  columns,
  headerColor,
  textHeaderColor,
  cellColor,
  font,
  id,
}) => {
  return (
    <TableHeader
      headerColor={headerColor || Colors.transparent}
      textColor={textHeaderColor || Colors.white}
      font={font}
      key={id}
    >
      <tr>
        {columns.map((column, index) => (
          <React.Fragment key={index}>
            <TableHeaderCell
              key={column.key}
              font={font}
              cellColor={cellColor}
              columnWidth={column.width}
            >
              {column.title}
            </TableHeaderCell>
            <CellSeparator width={"3px"} />
          </React.Fragment>
        ))}
      </tr>
    </TableHeader>
  );
};

export default TableHeaders;

